export const STORAGE_KEY = 'conformityCredentials';
